export default "__VITE_ASSET__Cc6CkNpR__"